// 节点筛选标签配置 - 每个车队独立配置
// 可以通过修改这个文件来定制每个车队显示的筛选标签

export const fleetFilterTags = {
  // GPT 车队筛选标签
  gpt: {
    accountType: [
      {
        id: 'plus-accounts',
        nameKey: 'nodeFilter.gpt.plus',
        name: 'Plus账户',
        color: 'gray', // 统一灰色
        filter: (node) => node.isPlus
      },
      {
        id: 'free-accounts',
        nameKey: 'nodeFilter.gpt.free',
        name: '免费账户',
        color: 'gray', // 统一灰色
        filter: (node) => !node.isPlus
      }
    ],
    status: [
      {
        id: 'idle',
        nameKey: 'nodeFilter.gpt.idle',
        name: '空闲推荐',
        color: 'gray', // 统一灰色
        filter: (node) => node.color === 'green' || node.busyLevel <= 30
      },
      {
        id: 'moderate',
        nameKey: 'nodeFilter.gpt.moderate',
        name: '适中负载',
        color: 'gray', // 统一灰色
        filter: (node) => node.color === 'yellow' || (node.busyLevel > 30 && node.busyLevel <= 70)
      }
    ]
  },

  // Claude 车队筛选标签
  claude: {
    accountType: [
      {
        id: 'max-accounts',
        nameKey: 'nodeFilter.claude.max',
        name: 'Max',
        color: 'gray', // 统一灰色
        filter: (node) => node.isMax || node.accountType === 'max'
      },
      {
        id: 'pro-accounts',
        nameKey: 'nodeFilter.claude.pro',
        name: 'Pro',
        color: 'gray', // 统一灰色
        filter: (node) => node.isPro && !node.isMax
      },
      {
        id: 'free-accounts',
        nameKey: 'nodeFilter.claude.free',
        name: 'Free',
        color: 'gray', // 统一灰色
        filter: (node) => !node.isPro && !node.isMax
      }
    ]
  },

  // Grok 车队筛选标签
  grok: {
    accountType: [
      {
        id: 'super-accounts',
        nameKey: 'nodeFilter.grok.super',
        name: 'Super',
        color: 'gray', // 统一灰色
        filter: (node) => node.isSuper
      },
      {
        id: 'free-accounts',
        nameKey: 'nodeFilter.grok.free',
        name: 'Free',
        color: 'gray', // 统一灰色
        filter: (node) => !node.isSuper
      }
    ]
  },

  // Sora 车队筛选标签 - 不需要筛选
  sora: {
    // 空配置，不显示任何筛选标签
  },

  // Gemini 车队筛选标签
  gemini: {
    accountType: [
      {
        id: 'pro-accounts',
        nameKey: 'nodeFilter.gemini.pro',
        name: 'PRO',
        color: 'gray', // 统一灰色
        filter: (node) => node.isPro || node.label === 'PRO'
      },
      {
        id: 'free-accounts',
        nameKey: 'nodeFilter.gemini.free',
        name: 'Free',
        color: 'gray', // 统一灰色
        filter: (node) => !node.isPro && node.label === 'free'
      }
    ]
  },

  // GPT 主力车队筛选标签 - 专门为gpt-backup配置
  'gpt-backup': {
    accountType: [
      {
        id: 'team-accounts',
        nameKey: 'nodeFilter.gptBackup.team',
        name: 'Team',
        color: 'gray', // 统一灰色
        filter: (node) => node.label === 'TEAM' || node.isTeam === true
      },
      {
        id: 'plus-accounts',
        nameKey: 'nodeFilter.gptBackup.plus',
        name: 'Plus',
        color: 'gray', // 统一灰色
        filter: (node) => node.label === 'PLUS' || (node.isSuper === true && node.label !== 'TEAM')
      }
    ],
    intelligence: [
      {
        id: 'full-power',
        nameKey: 'nodeFilter.gptBackup.fullPower',
        name: '满血',
        color: 'gray', // 统一灰色
        filter: (node) => node.isFullPower === true
      },
      {
        id: 'degraded-power',
        nameKey: 'nodeFilter.gptBackup.degradedPower',
        name: '降智',
        color: 'gray', // 统一灰色
        filter: (node) => node.isFullPower === false
      }
    ],
    renewal: [
      {
        id: 'auto-renewal',
        nameKey: 'nodeFilter.gptBackup.autoRenewal',
        name: '月续',
        color: 'gray', // 统一灰色
        filter: (node) => node.autoRenewal === true
      },
      {
        id: 'no-renewal',
        nameKey: 'nodeFilter.gptBackup.noRenewal',
        name: '不续',
        color: 'gray', // 统一灰色
        filter: (node) => node.autoRenewal === false
      }
    ]
  }
};

// 获取标签的颜色样式
export const getTagColorStyles = (color) => {
  const styles = {
    gray: {
      bg: 'bg-gray-100 hover:bg-gray-150 border-gray-200',
      activeBg: 'bg-gray-600 border-gray-700',
      text: 'text-gray-700',
      activeText: 'text-white'
    },
    green: {
      bg: 'bg-green-100 hover:bg-green-200 border-green-300',
      activeBg: 'bg-green-500 border-green-600',
      text: 'text-green-700',
      activeText: 'text-white'
    },
    yellow: {
      bg: 'bg-yellow-100 hover:bg-yellow-200 border-yellow-300',
      activeBg: 'bg-yellow-500 border-yellow-600',
      text: 'text-yellow-700',
      activeText: 'text-white'
    },
    orange: {
      bg: 'bg-orange-100 hover:bg-orange-150 border-orange-200',
      activeBg: 'bg-orange-500 border-orange-600',
      text: 'text-orange-700',
      activeText: 'text-white'
    },
    red: {
      bg: 'bg-red-100 hover:bg-red-200 border-red-300',
      activeBg: 'bg-red-500 border-red-600',
      text: 'text-red-700',
      activeText: 'text-white'
    },
    blue: {
      bg: 'bg-blue-100 hover:bg-blue-200 border-blue-300',
      activeBg: 'bg-blue-500 border-blue-600',
      text: 'text-blue-700',
      activeText: 'text-white'
    },
    purple: {
      bg: 'bg-purple-100 hover:bg-purple-200 border-purple-300',
      activeBg: 'bg-purple-500 border-purple-600',
      text: 'text-purple-700',
      activeText: 'text-white'
    }
  };
  
  return styles[color] || styles.gray;
};

// 默认启用的筛选器配置 - 每个车队独立
export const defaultFilterConfig = {
  // 每个车队默认启用的筛选分类
  fleetCategories: {
    gpt: ['accountType', 'status'],                    // GPT车队显示账户类型和状态
    'gpt-backup': ['accountType', 'intelligence', 'renewal'], // GPT主力车队显示账户类型、智能模式、续费方式
    claude: ['accountType'],                       // Claude车队只显示账户类型
    grok: ['accountType'],                         // Grok车队只显示账户类型
    sora: [],                                      // Sora车队不显示筛选标签
    gemini: ['accountType']                        // Gemini车队显示账户类型
  },
  
  // 每个车队的默认选中标签 - 不选择任何筛选，显示全部
  defaultSelected: {
    // 不设置默认选中，让用户主动选择筛选条件
  }
};